import { Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { SPACES } from 'src/constants'

interface IStylesProps {
  hasPassed?: boolean
  isActive?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  stepsWrapper: {
    '&&': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',

      width: '100%',
    },
  },
  stepWrapper: ({ hasPassed, isActive }: IStylesProps) => ({
    '&&': {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexDirection: 'column',

      height: '54px',
    },
    '&:not(:first-child)': {
      '&::before': {
        content: '""',
        display: 'block',
        position: 'absolute',
        top: '10px',
        left: '-38px',
        width: '40px',
        height: '1px',

        backgroundColor:
          hasPassed || isActive ? theme.palette.custom.primary : theme.palette.custom.grey2,
      },
    },
  }),
  stepIcon: {
    marginTop: 6,
  },
  stepCircle: ({ hasPassed, isActive }: IStylesProps) => ({
    '&&': {
      marginBottom: isActive ? SPACES.xs : 0,
      marginTop: isActive ? 0 : SPACES.xxxs,

      width: isActive ? 20 : 10,
      height: isActive ? 20 : 10,

      borderRadius: '50%',
      backgroundColor:
        hasPassed || isActive ? theme.palette.custom.primary : theme.palette.custom.grey2,
    },
  }),
  stepText: ({ hasPassed, isActive }: IStylesProps) => ({
    '&&': {
      color: isActive || hasPassed ? theme.palette.custom.primary : theme.palette.custom.grey2,
    },
  }),
}))

export default useStyles
